
export const uppercaseFirstLetter = (string: string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Simple wrapper for making POST requests to APIs
 */
export const fetchData = async (requestData: any, url: string): Promise<any> => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        });

        if (!response.ok) {
            throw new Error('API request failed');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};

export const myStyles = {
    container: {
    padding: 3,
    bgcolor: 'background.default',
    color: 'text.primary',
    minHeight: '100vh',
    },
    card: {
    bgcolor: 'background.paper',
    color: 'text.primary',
    height: '100%',
    },
    activeChip: {
    bgcolor: 'success.dark',
    color: 'success.contrastText',
    },
    inactiveChip: {
    bgcolor: 'warning.dark',
    color: 'warning.contrastText',
    },
    iconColor: {
    color: 'primary.main',
    },
    actionButton: {
    borderColor: 'primary.main',
    color: 'primary.main',
    },
    receiptSection: {
    marginTop: 4,
    marginBottom: 2,
    },
    emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 4,
    textAlign: 'center',
    },
    iconContainer: {
    bgcolor: 'action.hover',
    padding: 2,
    borderRadius: 1,
    marginBottom: 2,
    },
};